import React, { useContext, useEffect, useState } from "react";
import localforage from "localforage";
import PropTypes from "prop-types";
import styles from "./Gift.module.scss";
import closeIcon from "./close.svg";
import saveIcon from "./save.svg";
import shareIcon from "./share.svg";
import MainButton from "../MainButton/MainButton.jsx";
import { LanguageContext } from "../../contexts/LanguageContext.jsx";
import { STORAGE_KEYS } from "../../constants/storage";

import gifts from "../../gifts.js";

const STORAGE_KEY = "selectedGift";

const Gift = ({ onClose }) => {
  const { interfaceText, language } = useContext(LanguageContext);
  const [giftIndex, setGiftIndex] = useState(null);
  const [gift, setGift] = useState(null);
  const [cachedImage, setCachedImage] = useState(null);

  useEffect(() => {
    const fetchGift = async () => {
      const savedIndex = await localforage.getItem(STORAGE_KEY);

      if (savedIndex !== null && gifts[savedIndex]) {
        setGiftIndex(savedIndex);
        setGift(gifts[savedIndex]);
      } else {
        const randomIndex = Math.floor(Math.random() * gifts.length);
        setGiftIndex(randomIndex);
        setGift(gifts[randomIndex]);
        await localforage.setItem(STORAGE_KEY, randomIndex);
      }
    };

    fetchGift();
  }, []);

  useEffect(() => {
    const loadCachedImage = async () => {
      if (gift) {
        const cachedImageBlob = await localforage.getItem(
          `${STORAGE_KEYS.IMAGES}_${gift.image}`
        );
        if (cachedImageBlob) {
          setCachedImage(URL.createObjectURL(cachedImageBlob));
        }
      }
    };

    loadCachedImage();

    return () => {
      if (cachedImage) {
        URL.revokeObjectURL(cachedImage);
      }
    };
  }, [gift]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = cachedImage || gift.image;
    link.download = "gift.png";
    link.click();
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: gift.title[language],
          text: gift.description[language],
          files: [
            new File([cachedImage || gift.image], "gift.png", {
              type: "image/png",
            }),
          ],
        });
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      alert("Web Share API is not supported in your browser.");
    }
  };

  if (gift === null) return null;

  return (
    <div className={styles.overlay}>
      <button className={styles.closeButton} onClick={onClose}>
        <img src={closeIcon} alt="Close" />
      </button>
      <div className={styles.content}>
        <h1 className={styles.title}>{gift.title[language]}</h1>
        <img
          src={cachedImage || gift.image}
          alt="Gift"
          className={styles.giftImage}
        />
        <p className={styles.description}>{gift.description[language]}</p>
        <div className={styles.buttons}>
          <MainButton onClick={handleDownload}>
            <img className={styles.buttonIcon} src={saveIcon} alt="Save" />
          </MainButton>
          <MainButton onClick={handleShare} size={"small"}>
            <img className={styles.buttonIcon} src={shareIcon} alt="Share" />
          </MainButton>
        </div>
      </div>
    </div>
  );
};

Gift.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Gift;
